export default __webpack_public_path__ + "media/images/message-bubble-03f7fd4efd0761a1d440ff1a6b79c16e.svg";